/* eslint-disable max-len */
import React from "react"
import {useDispatch } from 'react-redux';
import {useState} from 'react'
import { removeRow } from "../../StudentAttendanceSlice";
import TextSection from '../../../../../../components/ToolTip/TextSection';

export default function TableBody({
    student,
    index,
    selectedAttendanceRecords,
    setAttendanceRecords,
    handleFetchStudentAttendance,
    selectedDate,
    type,
    disableRemove
}){
    const dispatch=useDispatch()
    const [hover, sethover] = useState('')
    function handleDeleteStudentRow(){
        if (disableRemove) return
        setAttendanceRecords(selectedAttendanceRecords?.filter((item)=>(type === "staff" ? item.staff_id!==student?.staff_id :  item.student_id!==student?.student_id)))
        dispatch(removeRow(type === "staff" ? student.staff_id : student.student_id))
        handleFetchStudentAttendance(selectedDate,type === "staff" ? student.staff_id : student?.student_id)
    }
    return(
        <>

            <tr class="">
                <td class="px-5 py-3 text-f2 font-normal text-[#031624] ">{type === "staff" ? student?.employee_number : student?.student_id}
                </td>
                <td class="px-5 py-3 text-f2 font-normal text-[#031624] text-start"><span  title={type === "staff" ? student?.full_name : student?.student_name}>{type === "staff" ? student?.full_name : student?.student_name}</span>
                </td>
                <td class="px-5 py-3 text-f2 font-normal text-[#031624] text-start"><span  title={type === "staff" ? student?.staff_type : student?.class_name}>{type === "staff" ? student?.staff_type : student?.gender}</span></td>
                <td class="px-5 py-3 text-f2 font-normal text-[#031624] text-start ">
                    <div class="relative">
                        <>{hover === 'modify'  &&
                        <div className='relative top-12 -left-[13px]'>
                            <TextSection text='Remove' show from={'academicreports'} />
                        </div>}
                        </>
                        {selectedAttendanceRecords?.length>1 &&
                        <button 
                            disabled={disableRemove}
                            onClick={handleDeleteStudentRow}
                            class={`px-2.5 py-1 edit_value ${disableRemove ? 'cursor-not-allowed opacity-50' : ''}`} 
                            data-tooltip-target="panuploadInfo" 
                            data-tooltip-trigger="hover" 
                            data-tooltip-placement="top" 
                            type="button"
                        >
                            <img loading="lazy" decoding="async" src="/images/x-circle.svg" alt="img" class="w-6 h-6" onMouseEnter={()=>{sethover('modify')}} 
                                onMouseLeave={()=>{sethover('')}} />
                        </button>}
                        
                    </div>
                </td>
            </tr>
                    
                   
                    
            
        </>
    )
}
